/**
 * Patient title
 */
export enum PatientTitle {
    Dr = 'Dr',
    Prof = 'Prof',
}
